/* eslint-disable react/no-unescaped-entities */
import PublicPageLayout, { Section } from "@/components/PublicPageLayout";

export default function About() {
  return (
    <PublicPageLayout
      eyebrow="About"
      title="Why this exists"
      intro="The AI Took My Job is a calm, practical companion for anyone whose role is shifting because of artificial intelligence. We help you understand what's happening, who you are, and what you could do next."
      testid="about-page"
    >
      <Section title="Our mission" testid="about-mission">
        <p>
          AI is reshaping work faster than most career services can adapt. We built this platform
          for the people in the middle of that change — the journalist who lost a beat to
          automation, the call-centre agent whose desk was retired, the designer being told to
          "just prompt it." You deserve more than generic advice and a job board.
        </p>
      </Section>

      <Section title="How we're different" testid="about-difference">
        <ul className="list-disc pl-6 space-y-2">
          <li>
            <span className="font-medium text-slate-900">Multi-model AI consensus.</span> Your
            career pathways come from OpenAI, Anthropic and Google Gemini working together — not a
            single biased model.
          </li>
          <li>
            <span className="font-medium text-slate-900">Five honest pathways.</span> Apply now,
            upskill, lateral move, retrain, or step back gracefully — we don't pretend everyone
            should become a developer.
          </li>
          <li>
            <span className="font-medium text-slate-900">Australian government support built-in.</span>{" "}
            We screen you against real federal and state programs you may already qualify for.
          </li>
          <li>
            <span className="font-medium text-slate-900">Human-first, not hype-first.</span> No
            growth-hacked dashboards. No fake urgency. Just the clearest next step.
          </li>
        </ul>
      </Section>

      <Section title="Who we serve" testid="about-audience">
        <p>
          We focus on Australian workers across creative, administrative, technical and service
          roles. If your work is being displaced, restructured or quietly automated, this platform
          is for you.
        </p>
      </Section>

      <Section title="Our promise" testid="about-promise">
        <p>
          You'll always own your data. You'll always be able to cancel. And you'll always get a
          straight answer — even when the answer is "you might need to take a year to retrain."
        </p>
      </Section>
    </PublicPageLayout>
  );
}
